import * as React from 'react'

export const IconMessage = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#a)'>
      <path
        d='M2.25 3A2.25 2.25 0 0 0 0 5.25C0 6 .328 6.656.89 7.078l10.172 7.64a1.479 1.479 0 0 0 1.829 0l10.171-7.64C23.625 6.656 24 6 24 5.25 24 4.031 22.969 3 21.75 3H2.25ZM0 8.25V18c0 1.688 1.313 3 3 3h18c1.64 0 3-1.313 3-3V8.25l-10.219 7.688a3.023 3.023 0 0 1-3.61 0L0 8.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='currentColor' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
